import { ChangeDetectionStrategy, Component, Input } from '@angular/core'
import { UserState } from '@ftr/ui-user'
import { Store } from '@ngxs/store'

@Component({
  selector: 'ftr-help-platform-support',
  templateUrl: './help-platform-support.component.html',
  styleUrls: ['./help-platform-support.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class HelpPlatformSupportComponent {
  @Input() isLoggedIn: boolean

  readonly currentUser$ = this.store.select(UserState.user)

  constructor(private readonly store: Store) {}
}
